import {SET_CURRENT_REVIEWS} from "./action_reviews";

const INITIAL_STATE = {
    currentReviews: []
}

const reviewsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CURRENT_REVIEWS:
            return {
                ...state,
                currentReviews: action.payload
            }
        default:
            return state;
    }
}

export default reviewsReducer;